// extracted by mini-css-extract-plugin
export default {"content":"NotificationSendModal_content__XNOBo","notificationsList":"NotificationSendModal_notificationsList__Wm1bE","empty":"NotificationSendModal_empty__m1LEB"};